<template>
  <div>
    <el-input
      v-model="license"
      :class="{ 'is-error': warning }"
      :placeholder="placeholder"
      :tabindex="tabindex"
      @change="handleChange"
      @input="handleInput"
    />
    <div v-if="warning" class="error-message">{{ errorMessage }}</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: "Licencia",
    },
    tabindex: String,
    required: Boolean,
    errorMessage: {
      type: String,
      default: "La licencia que has introducido no es válida",
    },
    workgroupId: Number,
  },
  data() {
    return {
      license: "",
      taxiId: "",
      warning: false,
      reloaded: false,
    };
  },
  watch: {
    value() {
      this.fillTaxiLicense();
    },
  },
  created() {
    if (this.value) {
      this.fillTaxiLicense();
    }
  },
  computed: {
    ...mapGetters("app", ["wgTaxis"]),
    taxis() {
      return this.wgTaxis(this.workgroupId);
    },
  },
  methods: {
    ...mapActions("app", ["reloadWgTaxis"]),
    fillTaxiLicense() {
      this.taxiId = this.value;
      if (!this.license) {
        this.license = this.taxis.find((t) => t.id === this.taxiId)?.license;
      }
    },
    handleInput() {
      this.warning = false;
    },
    async handleChange() {
      const taxi = this.taxis.find((t) => t.license === this.license);
      if (!taxi && !this.reloaded) {
        this.reloaded = true;
        await this.reloadWgTaxis(this.workgroupId);
        this.handleChange();
      } else if (!taxi) {
        this.license = "";
        this.warning = true;
      }
      this.$emit("input", taxi?.id || null);
      this.$emit("change", taxi?.id || null);
    },
  },
};
</script>

<style lang="scss" scoped>
.error-message {
  color: #c03639;
  font-size: 11px;
  margin-top: -6px;
}
</style>
